module.exports = __webpack_public_path__ + "img/NL195.f98a52e5.svg";